import { useNavigate } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import { Footer } from './Footer';
import { Navigation } from './Navigation';
import { useLanguage } from '../context/LanguageContext';

export const PageShell = ({ children, testId }) => (
  <div className="min-h-screen bg-white" data-testid={testId}>
    <Navigation />
    {children}
    <Footer />
  </div>
);

export const PageHero = ({ label, title, accent, subtitle, image }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  return (
    <section className="relative pt-32 pb-16 md:pt-40 md:pb-20 bg-slate-900 overflow-hidden">
      {image && (
        <div
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{ backgroundImage: `url(${image})` }}
        ></div>
      )}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900/50 via-slate-900/70 to-slate-900"></div>
      <div className="relative max-w-5xl mx-auto px-6 md:px-12">
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-1.5 text-slate-400 hover:text-white text-sm font-semibold mb-6 transition-colors"
        >
          ← {t.coachPage.back}
        </button>
        <p className="overline text-sky-400 mb-3">{label}</p>
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white tracking-tight mb-4 max-w-3xl">
          {title} {accent && <span className="gradient-text">{accent}</span>}
        </h1>
        {subtitle && <p className="text-lg md:text-xl text-slate-300 max-w-2xl">{subtitle}</p>}
      </div>
    </section>
  );
};

export const BookCTA = ({ url, label, secondary }) => (
  <a
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    className={`inline-flex items-center gap-2 px-6 py-3 rounded-full font-bold transition-colors ${secondary ? 'bg-white text-slate-900 hover:bg-slate-100 border border-slate-200' : 'bg-blue-600 text-white hover:bg-blue-700'}`}
  >
    {label}
    <ExternalLink className="w-4 h-4" />
  </a>
);
